export async function importModule() {
  return await import(/* webpackChunkName: "froala-editor" */ 'froala-editor/js/froala_editor.pkgd.min.js');
}